import Event from '@oppobrowser/lib-browser-event';
import template from './index.dot';
import { v4 as uuidv4 } from 'uuid';
import './index.scss';
import { $$ } from '@js/utils';
import { isBrowserVersionHigherThan, getEngine } from '../../js/utils';
import Feedback from '../../js/feedback.js';
import { fetchEventCardInfo } from '../../js/api';

const EventHandler = {
  jumpSearchPage() {
    setTimeout(() => {
      let eventUrl = this.data?.data?.eventUrl
        ? this.data?.data?.eventUrl
        : this.data?.data?.url || '';
      let linkType = '';
      const urlType = eventUrl.indexOf('heytapbrowser:');
      if (urlType == -1 && eventUrl != '') {
        linkType = 'H5链接';
      } else if (urlType == -1 && eventUrl == '') {
        linkType = '';
      } else {
        linkType = 'deepLink';
      }
      const time = new Date().getTime();
      // 点击埋点
      let _data = {
        card_type: 'event事件卡',
        link_type: linkType,
        time: time,
        docId: this.docinfo.resourceId,
        url: this.data?.data?.eventUrl
          ? this.data?.data?.eventUrl
          : this.data?.data?.url || '',
      };
      window.wv.generalStat('20084801', '10012', '21034', _data);
      // 跳转
      location.href = eventUrl;
    }, 200);
  },
};

export default class EventCard {
  constructor(el, name, data = {}) {
    this.el = el;
    this.data = {};
    this.isReport = false;
    (this.searchId = ''), (this._eventHandler = {});
    this.docinfo = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this.docinfo = window.pageData.DOCINFO;

    // 初始化生成search_id
    this.searchId = uuidv4();

    this._bindEvent();
    this.getCardData();
  }
  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }
  // 曝光埋点
  dataExposure(eventUrl) {
    let linkType = '';
    const urlType = eventUrl.indexOf('heytapbrowser:');
    if (urlType == -1 && eventUrl != '') {
      linkType = 'H5链接';
    } else if (urlType == -1 && eventUrl == '') {
      linkType = '';
    } else {
      linkType = 'deepLink';
    }
    const time = new Date().getTime();
    let _data = {
      card_type: 'event事件卡',
      link_type: linkType,
      time: time,
      docId: this.docinfo.resourceId,
    };
    window.wv.generalStat('20084800', '10012', '21034', _data);
  }

  async getCardData() {
    const { sourceVal } = window.store;
    let params = {
      format: 'json',
      resourceFrom: sourceVal,
      // docId: '839373297207681024',
      // docId: '861831756834320384'
      docId: this.docinfo.resourceId,
    };
    try {
      const { data } = await fetchEventCardInfo(params);
      if (data.ret == 0) {
        this.data = {
          data: {
            resourceId: data.data.resourceId,
            mainTitle: data.data.mainTitle,
            subTitle: data.data.subTitle,
            eventUrl: data.data.eventUrl,
            url: data.data.url,
            latestUpdateTime: data.data.latestUpdateTime,
            isEventCard: data.data.isEventCard,
          },
        };
        this.render();
        let eventUrl = data.data.eventUrl
          ? data.data.eventUrl
          : data.data.url || '';
        this.dataExposure(eventUrl);
      } else {
        console.log('事件卡接口报错!');
      }
    } catch (e) {
      console.log('fetchEventCardInfo is error', e);
    }
  }

  adaptNightMode() {
    this.darkTheme = window.store.nightMode;
  }
  formatTime(data) {
    var date = new Date(data);
    var M =
      ( date.getMonth() + 1 ) + '月';
    var D = (date.getDate()) + '日' +' ';
    var h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return M + D + h + m;
  }
  render() {
    this.adaptNightMode();
    const { data } = this;
    let icon = require('@img/icon-event.png');
    let backIcon = !this.darkTheme
      ? require('@img/Back-right.png')
      : require('@img/Back-dark.png');
    let circleIcon = !this.darkTheme
      ? require('@img/icon_ellipse.png')
      : require('@img/icon_ellipse_dark.png');
    const latestUpdateTime = this.formatTime(
      data.data?.latestUpdateTime * 1000,
    );
    this.el.innerHTML = template({
      mainTitle: data.data?.mainTitle || '',
      subTitle: data.data?.subTitle || '',
      eventUrl: data.data?.eventUrl
        ? data.data?.eventUrl
        : data.data?.url || '',
      icon: icon,
      backIcon: backIcon,
      circleIcon: circleIcon,
      latestUpdateTime: latestUpdateTime,
      isEventCard: data.data?.isEventCard || 0,
    });
    new Feedback(this.el);
  }
}
